import classNames from 'classnames';

interface Step {
  number: number;
  title: string;
}

interface Props {
  steps: Step[];
  currentStep?: number;
}

const FormProgress = ({ steps, currentStep = 1 }: Props) => {
  const stepIsActive = (step: number) => {
    return step <= currentStep;
  };

  return (
    <ul className="form-progress">
      {steps.map((step: Step) => {
        const { number, title } = step;
        const stepClasses = classNames({
          'form-progress__step': true,
          [`form-progress__step--${number}`]: true,
          'form-progress__step--active': stepIsActive(number),
        });

        return (
          <li key={number} className={stepClasses} data-testid="step">
            <span className="form-progress__step-no">{number}</span>
            <span className="form-progress__step-title">{title}</span>
          </li>
        );
      })}
    </ul>
  );
};

export default FormProgress;
